import {
  BottomNavigation,
  BottomNavigationAction,
  makeStyles,
  Tab,
  Tabs,
  useMediaQuery
} from '@material-ui/core';
import {
  Assignment,
  Favorite,
  PlaylistAddCheck,
  Pause
} from '@material-ui/icons';
import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { setNavigationStorage } from './storageHelper';
const useStyles = makeStyles(() => ({
  navigateActive: {
    backgroundColor: 'white',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  }
}));

export const NavigationContext = React.createContext<number>(1);

const enabledRoutes = ['/', '/vastaukset', '/lomakkeet', '/tilaukset'];

const getInitialNavigation = (path: string) => {
  // Navigate to forms
  if (['/lomakkeet', '/lomake'].some((p) => path.includes(p))) {
    return 0;
  }
  // Navigate to forms
  if (['/vastaukset'].some((p) => path.includes(p))) {
    return 1;
  }
  // Navigate to ttl
  if (['/tilaukset', '/tilaukset'].some((p) => path.includes(p))) {
    return 1;
  }
  return 0;
};

const NavigationBar = (props: any) => {
  const location = useLocation();
  const initialNavigation = getInitialNavigation(location.pathname);
  const [bottomBarNavigation, setBottomBarNavigation] =
    React.useState(initialNavigation);
  const [redirectToReferrer, setRedirectToReferrer] = React.useState(false);
  const isMobileView = useMediaQuery('(max-width:640px)');

  useEffect(() => {
    if (redirectToReferrer) {
      setRedirectToReferrer(false);
    }
  }, [redirectToReferrer]);

  // Set navigation bar state if route between main views is handled under the views (eg. Lomakelista has a link to Täytetyt)
  useEffect(() => {
    if (location.pathname === '/vastaukset') {
      setBottomBarNavigation(1);
    }
  }, [location.pathname]);

  const classes = useStyles();

  if (redirectToReferrer && location.pathname !== '/') {
    return <Redirect to={'/'} />;
  }
  return (
    <>
      {enabledRoutes.includes(location.pathname) ? (
        <>
          {!isMobileView && (
            <>
              <Tabs
                style={{ marginTop: 24, marginBottom: '-32px' }}
                centered
                value={bottomBarNavigation}
                indicatorColor="primary"
                textColor="primary"
                TabIndicatorProps={{
                  style: {
                    display: 'none'
                  }
                }}
                onChange={(_, newValue) => {
                  setBottomBarNavigation(newValue);
                  setNavigationStorage(newValue);
                  setRedirectToReferrer(true);
                }}
              >
                <Tab
                  className={
                    bottomBarNavigation === 0 ? classes.navigateActive : ''
                  }
                  label="Lomakelista"
                />
                <Tab
                  className={
                    bottomBarNavigation === 1 ? classes.navigateActive : ''
                  }
                  label="Täytetyt"
                />
                <Tab
                  className={
                    bottomBarNavigation === 2 ? classes.navigateActive : ''
                  }
                  label="Keskeneräiset"
                />
                <Tab
                  className={
                    bottomBarNavigation === 3 ? classes.navigateActive : ''
                  }
                  label="Suosikit"
                />
              </Tabs>
              <NavigationContext.Provider value={bottomBarNavigation}>
                {props.children}
              </NavigationContext.Provider>
            </>
          )}
          {isMobileView && (
            <>
              <NavigationContext.Provider value={bottomBarNavigation}>
                {props.children}
              </NavigationContext.Provider>
              <BottomNavigation
                value={bottomBarNavigation}
                showLabels
                style={{
                  width: '100%',
                  position: 'fixed',
                  bottom: 0,
                  boxShadow:
                    '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
                }}
                onChange={(_, newValue) => {
                  setBottomBarNavigation(newValue);
                  setNavigationStorage(newValue);
                  setRedirectToReferrer(true);
                }}
              >
                <BottomNavigationAction
                  label="Lomakelista"
                  icon={<Assignment />}
                />
                <BottomNavigationAction
                  label="Täytetyt"
                  icon={<PlaylistAddCheck />}
                />
                <BottomNavigationAction
                  label="Keskeneräiset"
                  icon={<Pause />}
                />
                <BottomNavigationAction label="Suosikit" icon={<Favorite />} />
              </BottomNavigation>
            </>
          )}
        </>
      ) : (
        <>{props.children}</>
      )}
    </>
  );
};

export default NavigationBar;
